export default __webpack_public_path__ + "static/media/T16.e5cf234e.JPG";